import { api } from '@cwd/lib/main';

export interface List {
    ListId: string;
    Name: string;
    Description: string;
    Created: string;
    CreatedBy: CreatedBy;
    LastModified: string;
    ModifiedBy: ModifiedBy;
    ContactCount: number;
    ActiveImportsCount: number;
    ScheduledImportsCount: number;
    FailedImportsCount: number;
    Tags: string[];
}

export interface CreatedBy {
    UserId: string;
    FirstName: string;
    LastName: string;
    Name: string;
    UserName: string;
}

export interface ModifiedBy {
    UserId: string;
    FirstName: string;
    LastName: string;
    Name: string;
    UserName: string;
}

export interface ListContact {
    ListId: string;
    ContactId: string;
    AddedDateTime: string;
}

export interface Contact {
    SmsBounceCount: number;
    Consents: Consent[];
    Lists: List[];
    OpenPercentage: number;
    ClickPercentage: number;
    DataGroups: string[];
    ContactId: string;
    AccountId: string;
    ExternalId: string;
    Number: number;
    Email: string;
    EmailFormat: number;
    FirstName: string;
    LastName: string;
    Name: string;
    SmsNumber: string;
    GmtOffset: number;
    Created: string;
    LastModified: string;
    PhotoUrl: string;
    OptInDate: string;
    SourceType: number;
    SourceName: string;
    IsDeleted: boolean;
    IsAnonymized: boolean;
    IsActive: boolean;
    IsSmsActive: boolean;
    HasBounced: boolean;
    HasSmsBounced: boolean;
    Custom1: string;
    Custom2: string;
    Custom3: string;
    Custom4: string;
    Custom5: string;
    Custom6: string;
    Custom7: string;
    Custom8: string;
    Custom9: string;
    Custom10: string;
    PersonalReplyToEmail: string;
    PersonalFromName: string;
    Account: Account;
    Tags: Tag[];
    Categories: Category[];
    JobTitle: string;
    Salutation: string;
    StreetAddress: string;
    City: string;
    PostalCode: string;
    State: string;
    Country: string;
    Region: string;
    Gender: string;
    Birthday: string;
    CompstringName: string;
    Industry: string;
    LastNpsDate: string;
    LastNpsRating: string;
    LastCsatDate: string;
    LastCsatRating: string;
    Website: string;
    CustomLong1: string;
    CustomLong2: string;
    CustomDate1: string;
    CustomDate2: string;
    CustomNumeric1: string;
    CustomNumeric2: string;
    CustomNumeric3: string;
    CustomNumeric4: string;
    CustomNumeric5: string;
    CustomNumeric6: string;
}

export interface Consent {
    ConsentId: string;
    ConsentTemplate: ConsentTemplate;
    GivenAt: string;
    RevokedAt: string;
}

export interface ConsentTemplate {
    ConsentTemplateId: string;
    Text: string;
    CreatedAt: string;
}

export interface List {
    ListId: string;
    Name: string;
    Description: string;
}

export interface Account {
    AccountId: string;
    Name: string;
    UserAccountRoleName: string;
    ClientCompstring: string;
}

export interface Tag {
    TagId: string;
    Title: string;
}

export interface Category {
    CategoryId: string;
    Name: string;
    Description: any;
    IsPublic: boolean;
    IgnoreUnsubscribe: boolean;
}

export async function loadLists(): Promise<List[]> {
    return api.get('/Lists');
}

export async function loadContact(id: string): Promise<Contact> {
    return api.get('/Contacts/' + id);
}

export async function saveContactProperty(id: string, property: string, newVal: any): Promise<Contact> {
    return api.post('/Contacts/' + id + '/' + property, newVal);
}

export async function loadCategories(): Promise<Category[]> {
    return api.get('/Categories');
}

export interface Timeline {
    Account: Account;
    Type: number;
    TypeName: string;
    Url: string;
    PublicUrl: string;
    PreviewUrl: string;
    Title: string;
    Description: string;
    OccuredAt: string;
    HardBounce: boolean;
    BounceCount: number;
    BounceCode: string;
    BounceCategory: string;
    BounceDiagnosis: string;
    RecipientCount: number;
    OpenCount: number;
    ClickCount: number;
    ResponseCount: number;
    EventParticipantStatus: string;
    EventParticipantStatusName: string;
    ModifiedByUser: ModifiedBy,
    Data: string
}

export interface Account {
    AccountId: string;
    Name: string;
}

export async function loadTimeline(id: string): Promise<Timeline[]> {
    return api.get('/Contacts/' + id + '/Timeline');
}

export interface Consent {
    ConsentId: string;
    ConsentTemplate: ConsentTemplate;
    GivenAt: string;
    RevokedAt: string;
}

export interface ConsentTemplate {
    ConsentTemplateId: string;
    Text: string;
    CreatedAt: string;
}

export async function anonymizeContact(id: string): Promise<unknown> {
    return api.post('/Compliance/Anonymize?contactId=' + id);
}

export async function loadDataGroups(id: string): Promise<DataGroup[]> {
    return api.get('/Contacts/' + id + '/Datagroups');
}

export interface DataGroup {
    ObjectGroup: string;
    Values: Value[];
}

export interface Value {
    Key: string;
    TextValue?: string;
    DateValue?: string;
    NumericValue?: number;
    BoolValue: any;
}
